function getData(x, y) {
    let data = new Array(x.length);
    for (let i = 0; i < x.length; i++) {
        data[i] = { x: x[i], y: y[i] };
    }
    return data;
}
/**
 * Generate a jsgraph chart format from an array of Analysis
 */
export function getReactPlotJSON(analyses, query, options = {}) {
    const { enforceGrowing = false, xAxis: xAxisOptions = {}, yAxis: yAxisOptions = { labelSpace: 40 }, content: seriesOptions = { displayMarker: true }, dimensions = { width: 550, height: 500 }, ...otherOptions } = options;
    let content = [];
    let meta = [];
    let xAxis = null;
    let yAxis = null;
    for (const analysis of analyses) {
        let spectra = enforceGrowing
            ? analysis.getNormalizedSpectrum({
                selector: query,
                normalization: {
                    filters: [{ name: 'ensureGrowing' }],
                    keepYUnits: true,
                },
            })
            : analysis.getXYSpectrum(query);
        if (!spectra)
            continue;
        if (spectra.meta) {
            meta.push(spectra.meta);
        }
        xAxis = {
            id: 'x',
            label: spectra.variables.x.label,
            ...xAxisOptions,
            position: 'bottom',
            type: 'main',
        };
        yAxis = {
            id: 'y',
            label: spectra.variables.y.label,
            ...yAxisOptions,
            position: 'left',
            type: 'main',
        };
        const data = getData(spectra.variables.x.data, spectra.variables.y.data);
        const serie = {
            type: 'line',
            label: spectra.title,
            data,
            ...seriesOptions,
        };
        content.push(serie);
    }
    if (xAxis === null || yAxis === null) {
        throw new Error('The axes were not defined');
    }
    return {
        content,
        axes: [xAxis, yAxis],
        dimensions,
        meta,
        ...otherOptions,
    };
}
//# sourceMappingURL=data:application/json;base64,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